﻿/**
 * re_track_phonenumber.js
 * @author May Montazer
 */
define(['jquery', 'pubsub', 'generalUtilities', 'moduleUtilities'], function(
    $,
    pubsub,
    generalUtilities,
    moduleUtilities
) {
    //set up
    //-------------------------------------------

    'use strict';

    var module, selectors, values, elements;

    module = {};
    module.private = {};
    module.properties = {};

    selectors = {};
    elements = {};
    values = {};

    selectors.phoneNumberBtn = '.js-phone-track';

    //event handlers
    //-------------------------------------------

    /**
     * handleTrackPhone
     * @param {object} e event
     * @param {object} data response data
     */
    module.private.handleTrackPhone = function(userId) {
        var requestOptions, request, serviceObject;

        requestOptions = {};

        request = { targetUserId: userId };

        serviceObject = moduleUtilities.createServiceObject(request, module.properties, requestOptions);

        pubsub.publish('uiNeeds.NotificationPhoneView', serviceObject);
    };

    /**
     * Handle data event returned from service, determines success of fail and calls the corresponding function.
     * @param {object} e The pubsub event.
     * @param {object} data Data object from service.
     */
    module.private.handleDataTrackPhone = function(e, data) {
        var status;
        status = generalUtilities.prop(data, 'response.status');
        if (status !== 200) {
            pubsub.publish('loggly.error', {
                message: 'send notification phone view is failed - pageType: ' + window.pageType + JSON.stringify(data)
            });
        }
    };

    module.private.trackPhoneNumber = function revealPhoneNumber(e) {
        e.preventDefault();
        e.stopPropagation();

        if (
            $(e.currentTarget)
                .find('span')
                .hasClass('js-btn-reveal-phone')
        ) {
            var dataContext = e.currentTarget.dataset.context;
            var dataPhoneNumber = e.currentTarget.dataset.phonenumber;
            e.currentTarget.innerText = dataPhoneNumber;
            e.currentTarget.href = generalUtilities.stringFormat('tel:{0}', dataPhoneNumber);
            $(e.currentTarget)
                .find('span')
                .removeClass('js-btn-reveal-phone');

            // send a notfication
            module.private.handleTrackPhone(e.currentTarget.dataset.userid);

            // mixpanel
            var mixData = {
                type: 'reveal phone'
            };

            if (dataContext) {
                mixData.context = dataContext;
            }

            pubsub.publish('mixpanel.Intent', mixData);
        }
    };

    module.private.init = function(e, data) {
        var dateCreated;

        dateCreated = generalUtilities.prop(window, 'RESAAS.User2.CreatedDate');

        //set values
        module.properties.guid = data && data.guid ? data.guid : generalUtilities.uuid();

        elements.body = $('.re-page-outer-wrapper');

        //set internal event bindings
        elements.body.on('click', selectors.phoneNumberBtn, module.private.trackPhoneNumber);
    };

    //external event bindings
    //-------------------------------------------

    pubsub.subscribe('data.NotificationPhoneView', module.private.handleDataTrackPhone);

    module.private.init();

    //expose API
    //-------------------------------------------
    return module;
});
